export const professorData = {
  name: "Prof. Dr. B. Jagan Mohan Reddy",
  shortName: "B. Jagan Mohan Reddy",
  title: "Professor & BOS Chairman",
  department: "Department of Chemistry",
  university: "Adikavi Nannaya University",
  location: "Rajahmundry, Andhra Pradesh, India – 533 296",
  tagline: "IUPAC-2011 Young Scientist & 2019 A.P. Best Teacher Awardee",
  contact: {
    mobile: "+91-9347153270",
    email1: "professorjaganmohanreddychem@aknu.edu.in",
    email2: "jaganreddyprofessor@gmail.com",
    dob: "15-06-1974",
  },
  profiles: {
    vidwan: "https://vidwan.inflibnet.ac.in/profile/653188",
    googleScholar: "https://scholar.google.com/citations?user=MxYa8XQAAAAJ&hl=en",
    orcid: "https://orcid.org/0000-0001-9357-9610",
  },
  metrics: {
    publications: 82,
    citations: 788,
    hIndex: 13,
    i10Index: 22,
    phdsAwarded: 11,
    phdsOngoing: 9,
    patents: 6,
    books: 6,
    experience: 20,
    conferences: 157,
    guestLectures: 60,
    projects: 2,
    seminarsOrganized: 4,
    conferencesOrganized: 5,
    seminarsAttended: 335,
  },
  awards: [
    { year: "1994–1996", title: "1st Rank in M.Sc.", body: "Sri Venkateswara University" },
    { year: "2001", title: "M.Phil. with Distinction", body: "Sri Venkateswara University" },
    { year: "2005", title: "Ph.D. Awarded (Full-time Scholar)", body: "Sri Venkateswara University" },
    { year: "2007", title: "Post-Doctoral Fellowship", body: "POSTECH, South Korea" },
    { year: "2009", title: "DST-SERC Fast Track Young Scientist", body: "Dept. of Science & Technology, Govt. of India (₹19.8 Lakhs)" },
    { year: "2009", title: "Senior Research Fellow (SRF)", body: "CSIR, Govt. of India, New Delhi" },
    { year: "2011", title: "Young Scientist Award", body: "IUPAC World Chemistry Congress, Puerto Rico, USA" },
    { year: "2011", title: "Young Observer Award", body: "IUPAC, USA" },
    { year: "2018", title: "Outstanding Faculty in Chemistry — VIFA 2018", body: "Venus International Faculty Awards" },
    { year: "2019", title: "Best Teacher Award", body: "Government of Andhra Pradesh" },
    { year: "2019", title: "Science Academics Summer Research Fellowship", body: "IICT, Hyderabad (May–June 2019)" },
    { year: "2021", title: "Summer Research Fellowship", body: "Indian National Science Academy, Bangalore" },
    { year: "2022", title: "INSA Visiting Scientist Award", body: "Indian National Science Academy" },
  ],
  education: [
    { degree: "B.Sc.", year: "1994", division: "First Class", university: "Nagarjuna University" },
    { degree: "M.Sc. Chemistry", year: "1996", division: "First Class with Distinction (1st Rank)", university: "Sri Venkateswara University, Tirupathi" },
    { degree: "M.Phil.", year: "2001", division: "First Class with Distinction", university: "Sri Venkateswara University, Tirupathi" },
    { degree: "Ph.D.", year: "2005", division: "Full-time Scholar", university: "Sri Venkateswara University, Tirupathi" },
    { degree: "Post-Doctoral Fellowship", year: "2007", division: "Research Fellow", university: "POSTECH, Pohang University, South Korea" },
  ],
  phdThesis: {
    title: "A Study on Some Pyrrole, Pyrazole and Isoxazole Derivatives",
    supervisor: "Prof. V. Padmavathi, Sri Venkateswara University, Tirupathi",
  },
  experience: [
    { institution: "Adikavi Nannaya University, Rajamahendravaram", role: "Professor", duration: "19 Years" },
    { institution: "POSTECH, South Korea", role: "Post-Doctoral Fellow", duration: "1 Year" },
    { institution: "Hetero Drugs Pvt. Ltd. (Expicor Lab), Hyderabad", role: "Research Scientist", duration: "1 Year" },
    { institution: "Sri Kandula Obula Reddy Degree College", role: "Degree Lecturer", duration: "1 Year" },
    { institution: "Sri Vivekananda Degree College, Giddalur", role: "Degree Lecturer", duration: "2 Years" },
    { institution: "Dr. A.E.R Degree College, Tirupathi", role: "Degree Lecturer", duration: "2 Years" },
  ],
  adminPositions: [
    "Chief Warden, University College for Men, AKNU",
    "Head, Department of Chemistry, AKNU",
    "Skill Development Coordinator, AKNU",
    "Placement Officer, AKNU",
    "Assistant Dean Examination (P.G.), AKNU",
    "Chairman, Board of Studies, AKNU",
    "NSS Programme Officer & Coordinator, AKNU",
    "Finishing School Coordinator, AKNU",
    "Course Coordinator, M.Sc. Chemistry, AKNU",
  ],
  phdsAwarded: [
    { sno: 1, name: "N. Trimurthulu", fellowship: "CSIR NET JRF & SRF", title: "Application of Prins Cyclisation to Stereoselective Total Synthesis of Natural Products", year: "2012" },
    { sno: 2, name: "N. Siva Sankar Reddy", fellowship: "", title: "Total Synthesis of Tetrahydroisoquinoline and β-carboline alkaloids using Ellman's Chiral auxiliary", year: "2015" },
    { sno: 3, name: "R. Anjibabu", fellowship: "CSIR-NET JRF & SRF", title: "Stereoselective Synthesis of Solifenacin, Sitagliptin using tert-Butanesulfinamide and Development of Novel Methodologies", year: "2016" },
    { sno: 4, name: "N. Prudhvi Raju", fellowship: "CSIR-NET JRF & SRF", title: "Prins type cascade cyclizations for the synthesis of fused, bridged and Spiro tetrahydropyran/tetrahydrofuran derivatives", year: "2016" },
    { sno: 5, name: "A. Kavitha", fellowship: "", title: "The synthesis of Narbonolide, muamvitin and (S)-(5)-[(S)-6-hydroxyoctyl]furan-2(5H)-one", year: "2017" },
    { sno: 6, name: "Y. Vikram Reddy", fellowship: "", title: "Total synthesis of tetrahydroisoquinoline alkaloids and novel synthetic methodologies", year: "2018" },
    { sno: 7, name: "B. Someswara Rao", fellowship: "CSIR-NET JRF & SRF", title: "Design and synthesis of fused and bridged tetrahydropyran/tetrahydrofuran systems through Prins type cascade cyclization", year: "2018" },
    { sno: 8, name: "B. Madhavi Latha", fellowship: "", title: "Synthesis of Pyrazole, Oxadiazol, Thiazole, Triazole, Isoxazole hybrids and Evaluation of Their cytotoxic Activity", year: "2021" },
    { sno: 9, name: "G. Satya Sree", fellowship: "JRF APPCB", title: "Hydrothermal Approach for the Bi-metal oxide based Ternary nano composites for waste water treatment applications", year: "2022" },
    { sno: 10, name: "G. Sukumar", fellowship: "EMR", title: "New synthetic methodologies for benzimadazo-isoquinolines & azaflavanones and camphor based β-amino acid as new turn inducing template", year: "2024" },
    { sno: 11, name: "D. Narasimha Rao", fellowship: "EMR Full Time", title: "Role of organic nutrients on primary production in the Bay of Bengal", year: "2026" },
  ],
  recentPublications: [
    { title: "Development and validation of a novel stability indicating RP-UPLC method for the estimation of Leniolisib", journal: "Analytical Chemistry Letters", year: "2026", if: "1.6", status: "Under Review" },
    { title: "Design, Synthesis of New molecular hybrids of Imidazo[1,2-a]pyridine-1,3,4-oxadiazole linked 1,2,3-triazoles as potent EGFR targeting anti-breast cancer agents", journal: "Journal of Molecular Structure", year: "2026", if: "4.7", status: "Under Review" },
    { title: "Development and validation of a novel stability indicating RP–UPLC method for the estimation of Rezafungin", journal: "Spectroscopic Letters", year: "2026", if: "1.6", status: "Published" },
    { title: "Sources and spatial variability in dissolved organic nitrogen in the bay of Bengal and its role in supporting primary production", journal: "Regional Studies in Marine Science", year: "2025", if: "2.1", status: "Online" },
    { title: "Synthesis and Molecular Docking study of Beclomethasone dipropionate derivatives as Glucocorticoid Receptor Inhibitors", journal: "Asian Journal of Chemistry", year: "2025", if: "4.1", status: "Published" },
    { title: "Anticancer effect and apoptosis induction by azaflavone derivative in human prostate cancer cells", journal: "Apoptosis — Springer", year: "2022", if: "5.561", status: "Published" },
    { title: "Enhanced UV-Visible triggered photocatalytic degradation of Brilliant green by Reduced Graphene Oxide based NiO and CuO ternary nanocomposite", journal: "Arabian Journal of Chemistry", year: "2020", if: "6.212", status: "Published" },
    { title: "Biosynthesis of CMC-Guar gum–Ag0 nanocomposites for inactivation of food pathogenic microbes and its effect on the shelf life of strawberries", journal: "Carbohydrate Polymers — Elsevier", year: "2020", if: "10.723", status: "Published" },
  ],
  patents: [
    { no: 1, title: "An Improved process for the preparation of chloro substituted nitro thioanisole derivatives", appNo: "202441023282", status: "Application Filed — 25/03/2024" },
    { no: 2, title: "An Improved Process for synthesis of 2,4-Diaminobutyric acid", appNo: "202341033872", status: "Application Filed — 15/05/2023" },
    { no: 3, title: "Synthesis of L-Ectone from L-2,4-Diaminobutyric acid and purification", appNo: "202341035339", status: "Application Filed — 21/05/2023" },
    { no: 4, title: "A New Process for Synthesis of 4-Halophenylmethylsulphone Derivatives", appNo: "202341035339", status: "Application Filed — 21/05/2023" },
    { no: 5, title: "Three Dimensional nanoparticulate drug delivery Guidance system and Method thereof", appNo: "TEMP/E-1/58721/2021-CHE", status: "Published" },
    { no: 6, title: "Nanomaterials composition for drug delivery and method thereof", appNo: "TEMP/E-1/64319/2021-CHE", status: "Published" },
  ],
  books: [
    { title: "Synthesis of Tetrahydropyran/Tetrahydrofuran derivatives", authors: "Dr. B. Jagan Mohan Reddy, Dr. N. Prudhvi Raju", publisher: "LAP LAMBERT Academic Publishers", year: "2016" },
    { title: "Total Synthesis of Solifenacin, Sitagliptin and Novel Methodologies", authors: "Dr. B. Jagan Mohan Reddy, Dr. R. Anji Babu", publisher: "LAP LAMBERT Academic Publishers", year: "2016" },
    { title: "Synthesis of Narbonolide, Muamvatin and (S)-5-((S)-6-hydroxyoctyl)furan-2(5H)-one", authors: "Dr. B. Jagan Mohan Reddy, K.V.B. Ranjitha, A. Kavitha", publisher: "LAP LAMBERT Academic Publishers", year: "2020" },
    { title: "Synthesis of Ternary Nanocomposites via Hydrothermal Route and their Photocatalytic Activity", authors: "B. Jagan Mohan Reddy, G. Satya Sree, K.V.B. Ranjitha", publisher: "RATE — Recent Advancements in Engineering & Technology", year: "2020" },
    { title: "Modern Organic Synthesis – I", authors: "B. Jagan Mohan Reddy, K.V.B. Ranjitha, G. Satya Sree", publisher: "Sasidhar Reddy Publications", year: "2021" },
    { title: "Modern Organic Synthesis – II", authors: "B. Jagan Mohan Reddy, K.V.B. Ranjitha, G. Satya Sree et al.", publisher: "Sasidhar Reddy Publications", year: "2021" },
  ],
  collaborations: [
    "Dr. S. Chandrasekhar, Ex-Director, CSIR-Indian Institute of Chemical Technology, Hyderabad",
    "Dr. B. V. Subbareddy, Chief Scientist & Head, Centre for Semio Chemicals, CSIR-IICT, Hyderabad",
    "Dr. V. Jayathirtha Rao, Chief Scientist & Head, Crop Protection Chemicals, CSIR-IICT, Hyderabad",
  ],
  memberships: [
    "Life Member — Indian Science Congress, Calcutta",
    "Life Member — Chemical Research Society of India (CRSI)",
    "Life Member — Association of Chemistry Teachers (ACT), Mumbai",
    "Life Member — Indian Council of Chemists (ICC), Agra",
    "Life Member — Indira Gandhi Centre for Atomic Research (IGCAR), Kalpakam",
    "Life Member — Indian Red Cross Society",
    "Editorial Board Member — American Journal of Heterocyclic Chemistry (AJHC) since 2019",
    "Chief Consultant (Honorary) — Makore Labs Pvt. Ltd.",
  ],
  researchInterests: [
    "Synthetic Organic Chemistry",
    "Heterocyclic Chemistry",
    "Total Synthesis of Natural Products",
    "Drug Discovery & Anticancer Agents",
    "Nanomaterials & Nanocomposites",
    "Green Chemistry",
    "Spectroscopic Analysis",
    "Pharmaceutical Chemistry",
  ],
};
